export class CustomError extends Error {
  level = 'error';

  constructor(message) {
    super(message);
    this.name = this.constructor.name;

    // Capturing stack trace, excluding constructor call from it.
    Error.captureStackTrace(this, this.constructor);
  }
}

class Warning extends CustomError {
  level = 'warning';
}

export class InvalidSignatureError extends Warning {}

export class MissingQueryParametersError extends Warning {}

export class WorksheetNotFoundError extends Warning {}
